/* eslint-disable */
import convertList from '../convertList';
import sign from '../sign';
import  { envDomain } from '@/common/contact-selector/utils/domainConfig'
export default function(config) {
    const moreConfig = {
        totalState: false
    };

    return new Promise((resolve, reject) => {
        const data = {
            groupId: config.groupId,
            cookie: config.cookie || '',
            count: config.count || undefined
        };
        _getQQFriendListById(data).then(
            res => {
                if (res.data.friends && res.data.friends.length) {
                    config.parent.cookie = res.data.cookie;
                    config.parent.loaded = res.data.isEnd;
                    const list = convertList(
                        res.data.friends,
                        {
                            list: 'groupList',
                            groupName: 'name',
                            total: 'totalMember'
                        },
                        moreConfig,
                        config.nodeId
                    );
                    const oneWayUins = res.data.friends.filter(item => item.isOneWayFriend).map(item => `${item.uin}`);
                    const selfConfig = config.extendConfig;
                    console.log(selfConfig);
                    const newList = sign.oneWayRelationshipChain(list, 'QQFriend', {
                        oneWayUins,
                        ...selfConfig
                    });
                    console.log('oneWayUins', oneWayUins, newList, config);
                    const result = Object.assign(res.data, {
                        list: newList
                    });
                    resolve(result);
                } else {
                    resolve({
                        list: []
                    });
                }
            },
            err => {
                reject(err);
            }
        );
    });
}

function _getQQFriendListById(data) {
    return Vue.prototype.$_sAjax.crossGet(`${envDomain.gateway}/v1/qq/qqFriends`, {
        params: data
    });
}
